// extracted by mini-css-extract-plugin
export default {"listItem":"historyListItem_listItem__EJvMO","listText":"historyListItem_listText__OVstt"};